import {wmsHttp} from '@/utils/http/index.js'

/**
 * 根据商品id查找批属性枚举及批次枚举
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/20613
 */
export function getBatchAttrs(data) {
    return wmsHttp.post(
        '/warehouse_management_system/rule_batch_attribute/get_by_goods',
        data
    )
}

/**
 * 根据批属性和批次获取可用库存
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/16129
 */
export function getAvailableAmountByAttrs(data) {
    return wmsHttp.post(
        '/warehouse_management_system/batch_attribute/appoint',
        data
    )
}
